import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import { sharedConfig } from '@/pageConfig/shared';
// TODO: add og image
import og from '@/static/assets/home/og.png';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: "Lemonade's Partners Program | Grow Your Business!",
    description:
      'Tell the world about the most love insurance product out there, while earning $$ and creating real social impact.',
    ogImage: og.src,
    metaTitle: "Lemonade's Partners Program | Grow Your Business!",
  },
};
